import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { ClientData } from "../types";

export const editClient = (payload: ClientData) => {
   return apiClient<ApiResponse>("/v1/client", {
      method: "PUT",
      body: payload
   })
}
